module.exports = __webpack_public_path__ + "static/media/Instagram.27caba34.svg";